import {
    HttpHandler,
    HttpHeaderResponse,
    HttpInterceptor,
    HttpProgressEvent,
    HttpRequest,
    HttpResponse,
    HttpSentEvent,
    HttpUserEvent,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, distinctUntilChanged } from 'rxjs/operators';

import { ERRORS } from '@config/global-constants';
import { selectUserToken } from '@rpt-ngrx/selectors/session.selector';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private token: string;

    constructor(
        private router: Router,
        private store: Store,
    ) {
        this.store
            .select(selectUserToken)
            .pipe(distinctUntilChanged())
            .subscribe((token) => (this.token = token));
    }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<
        HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any
    > {
        return this.handleRequest(req, this.token, next);
    }

    addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
        if (req.url.indexOf('token') !== -1) {
            const modifiedReq = req.clone({
                responseType: 'text',
                headers: req.headers.append('Authorization', `Bearer ${token}`),
            });

            return modifiedReq;
        } else {
            const modifiedReq = req.clone({
                headers: req.headers.append('Authorization', `Bearer ${token}`),
            });

            return modifiedReq;
        }
    }

    handleRequest(req: HttpRequest<any>, token: string, next: HttpHandler) {
        return next.handle(this.addToken(req, token)).pipe(catchError((error) => this.errorHandler(error)));
    }

    errorHandler(res) {
        if (res.status === 401 || res.status === 403) {
            if (res && res['_body'] && res['_body']['error'] && res['_body']['error'] === ERRORS.EXPIRED_TOKEN) {
                this.router.navigate(['/login']);
            }
        }
        return throwError(res);
    }
}
